module.exports = __webpack_public_path__ + "img/upload.49c5df12.svg";